module.exports = __webpack_public_path__ + "img/green_007.550fe2a8.png";